"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextStepLastStep = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../../components/organisms");
const NextStepLastStep = () => {
    return (react_1.default.createElement(organisms_1.TimelineEntry, { title: 'Folgetermin' + '\n' + 'buchen', infoText: "Zun\u00E4chst muss die Videosprechstunde stattgefunden haben." }));
};
exports.NextStepLastStep = NextStepLastStep;
